// extracted by mini-css-extract-plugin
module.exports = {"editDocumentWindowModeSelector":"editDocumentWindowModeSelector__lPeox","lineItemsCounterBadge":"lineItemsCounterBadge__1JTf-"};